<template>
  <section>
    <ModulesWrapper>
      <ModuleContainer
        v-for="(content, i) in visibleContent"
        v-bind:key="`home-${i}`"
        :Data="content"
      />
    </ModulesWrapper>
    <LoadMore>
      <button v-if="!allLoaded" v-on:click="loadMore">
        <Marquee :Copy="'View More /&nbsp;'"/>
      </button>
    </LoadMore>
  </section>
</template>

<script>
/* eslint-disable */
import styled from 'vue-styled-components'
import concat from 'lodash/concat'
import mixin from 'lodash/mixin'
import take from 'lodash/take'
import takeRight from 'lodash/takeRight'
import shuffle from 'lodash/shuffle'
import _ from 'lodash/wrapperLodash'
import * as x from '@/styles/mixins'
import { colors } from '@/styles/theme'
import ModuleContainer from './ModuleContainer'
import Marquee from '@/components/Marquee'

mixin(_, {
  concat: concat,
  take: take,
  shuffle: shuffle,
  takeRight: takeRight
})

// STYLES
const LoadMore = styled.div`
  width: 100%;
  height: 8rem;
  button {
    ${x.flexCenteredAll};
    margin: 0 auto;
    width: 100%;
    height: 100%;
    border-top: 3px solid white;
    border-bottom: 3px solid white;
    background-color: ${colors.black};
    color: ${colors.white};
    text-transform: uppercase;
    letter-spacing: 2px;
    border-radius: 0;
    ${x.media.hover`
      &:hover {
        color: ${colors.fc[9]};
        border-top: 3px solid ${colors.fc[6]};
        border-bottom: 3px solid ${colors.fc[6]};
      }
    `}
  }
`

const ModulesWrapper = styled.ul`
  ${x.flexRowWrap};
  width: 100%;
  min-height: 100vh;
`

// VUE
export default {
  components: {
    ModulesWrapper,
    ModuleContainer,
    LoadMore,
    Marquee
  },
  props: [
    'Data'
  ],
  data () {
    return {
      content: false,
      visibleContent: false,
      loadIncrement: 28,
      modulesVisible: 28,
      allLoaded: false
    }
  },
  created () {
    this.combineData()
  },
  methods: {
    zip (source1, source2, source3) {
      let result=[];
      source1.forEach((o, i) => {
        result.push(o)
        result.push(source2[i])
        if (source3) {
          result.push(source3[i])
        }
      })
      return result
    },
    combineData () {
      const topCount = this.Data.artists.length
      const releaseLength = this.Data.releases.length
      const newsLength = this.Data.news.length
      // TOP CONTENT
      const newsTop = _.take(this.Data.news, topCount)
      const releasesTop = _.take(this.Data.releases, topCount)
      const topContent = this.zip(this.Data.artists, newsTop, releasesTop)
      
      // BOTTOM CONTENT
      const bottomReleaseLength = releaseLength - topCount
      const bottomNewsLength = newsLength - topCount
      const middleReleaseLength = bottomNewsLength * 2
      const remainingReleaseLength = bottomReleaseLength - middleReleaseLength


      const bottomNews = _.takeRight(this.Data.news, bottomNewsLength)
      const bottomReleases = _.takeRight(this.Data.releases, bottomReleaseLength)
      
      const middleReleases = _.take(bottomReleases, (bottomNewsLength * 2))
      
      const middleReleasesA = middleReleases.slice(0, bottomNewsLength);
      const middleReleasesB = middleReleases.slice(bottomNewsLength, middleReleases.length);
      const middleContent = this.zip(bottomNews, middleReleasesA, middleReleasesB)

      const remainingReleases = _.takeRight(bottomReleases, remainingReleaseLength)
      const bottomContent = _.concat(middleContent, remainingReleases)
      this.content = _.concat(topContent, bottomContent)
      this.setVisibleContent()
    },
    setVisibleContent () {
      this.visibleContent = _.take(this.content, this.modulesVisible)
    },
    loadMore () {
      if (this.modulesVisible < this.content.length) {
        this.modulesVisible = this.modulesVisible + this.loadIncrement
        this.setVisibleContent()
      }
      if (this.modulesVisible >= this.content.length) {
        this.allLoaded = true
      }
    }
  }
}
</script>
